import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryNav />
        <LatestSection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "屁屁影院 - 高清影视在线观看平台",
            "description": "屁屁影院是您的首选在线观影平台，提供海量高清电影、电视剧、动漫免费在线播放。",
            "url": "https://streampops.github.io/",
            "isPartOf": {
              "@type": "WebSite",
              "name": "屁屁影院",
              "url": "https://streampops.github.io/"
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首页",
                  "item": "https://streampops.github.io/"
                }
              ]
            }
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "屁屁影院是否需要注册才能观看？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "不需要。屁屁影院所有影视资源均可免费在线观看，无需注册或登录，打开网站即可享受高清观影体验。"
                }
              },
              {
                "@type": "Question",
                "name": "影片的画质如何？是否支持高清播放？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "屁屁影院所有影片均提供1080P高清画质，部分热门影片更支持4K超清画质。"
                }
              },
              {
                "@type": "Question",
                "name": "影片更新频率是怎样的？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "我们拥有专业的资源更新团队，热门电影和电视剧通常在上线后24小时内更新。"
                }
              },
              {
                "@type": "Question",
                "name": "是否支持手机和平板观看？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "屁屁影院采用响应式设计，完美适配手机、平板、电脑等各种设备。"
                }
              }
            ]
          })
        }}
      />
    </>
  );
}